var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{attrs:{"name":"home","page-content":false}},[_c('f7-navbar',{attrs:{"sliding":false}},[_c('f7-nav-left'),_vm._v(" "),_c('f7-nav-title',{attrs:{"sliding":""}},[_vm._v("Panel de control")]),_vm._v(" "),_c('f7-nav-right')],1),_vm._v(" "),_c('f7-page-content',{staticClass:"full-height dashboard"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }